import { useEffect, useState } from "react";

enum AiDeviceProperties {
  LABEL = "라벨",
  SERIAL_NUMBER = "시리얼 번호",
  AI_DEVICE_TYPE_ID = "기기 모델",
  NETWORK_DEVICE_ID = "네트워크 기기",
  CURRENT_STATUS = "현재 상태	",
}

const useAIDeviceList = (initialPage: number) => {
  const transformData = (rawData: any[]): Record<AiDeviceProperties, any>[] => {
    return rawData.map((item) => ({
      [AiDeviceProperties.LABEL]: item.label,
      [AiDeviceProperties.SERIAL_NUMBER]: item.serialNumber,
      [AiDeviceProperties.AI_DEVICE_TYPE_ID]: item.aiDeviceTypeId,
      [AiDeviceProperties.NETWORK_DEVICE_ID]: item.networkDeviceId,
      [AiDeviceProperties.CURRENT_STATUS]: item.currentStatus,
    }));
  };

  const [isFetchingComplete, setIsFetchingComplete] = useState(false);

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [data, setData] = useState<any[]>([]);
  const [count, setCount] = useState<number>();
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState<string[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);

  const handleDeleteClick = (aiDeviceId: string) => {
    const result = window.confirm("삭제하시겠습니까?");
    if (result) {
      fetch(`${process.env.REACT_APP_URL}/ai-device/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ aiDeviceId: aiDeviceId }),
      })
        .then(async (response) => {
          if ((await response.json()) === 1451) {
            // 키 참조 에러처리
            alert("삭제에 실패했습니다.");
          } else {
            window.location.reload();
          }
        })
        .catch((error) => {
          alert("삭제에 실패하였습니다.");
        });
    }
  };

  const fetchData = async (page: any) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/ai-device/list?page=${page}`
      );
      const jsonData = await response.json();
      const transformedData = transformData(jsonData.data.list || []);
      //원본 전체 데이터 보여지는데이터는 tableData로 관리
      setData((prevData) => [...prevData, ...transformedData]);

      if (columns.length === 0 && transformedData.length > 0) {
        const newColumns = Object.keys(transformedData[0]);
        setColumns(newColumns);
      }

      const countResponse = await fetch(
        `${process.env.REACT_APP_URL}/ai-device/list`
      );
      const countJsonData = await countResponse.json();

      const totalDataCount = countJsonData.data.count;
      setCount(countJsonData.data.count);

      if (
        transformedData.length === 0 ||
        totalDataCount <= data.length + transformedData.length
      ) {
        setIsFetchingComplete(true);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  return {
    data,
    loading,
    currentPage,
    nextPage,
    count,
    columns,
    tableData,
    setTableData,
    handleDeleteClick,
    isFetchingComplete,
  };
};

export default useAIDeviceList;
